import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { ThemeToggle } from "./ThemeToggle";
import { GlobalSearch } from "./GlobalSearch";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator, } from "./ui/breadcrumb";
import { Button } from "./ui/button";
import { DropdownMenu, } from "./ui/dropdown-menu";
import { ChevronRight, Home, CheckCircle, AlertTriangle, Info, Menu } from "lucide-react";
const tabTitles = {
    'dashboard': 'Dashboard',
    'general-addons': 'General Addons',
    'product-addons': 'Product Addons',
    'cart-checkout-addons': 'Cart & Checkout',
    'shipping-payment': 'Shipping & Payment',
    'marketing-sales': 'Marketing & Sales',
    'seo-performance': 'SEO & Performance',
    'customer-management': 'Customer Management',
    'inventory-management': 'Inventory Management',
    'security-compliance': 'Security & Compliance',
    'integrations-api': 'Integrations & API',
    'content-design': 'Content & Design',
    'mobile-apps': 'Mobile & Apps',
    'automation-workflows': 'Automation & Workflows',
    'reports-analytics': 'Reports & Analytics',
    'free-addons': 'Free Addons',
    'license-updates': 'License & Updates',
    'help-docs': 'Help & Documentation'
};
export function ContentHeader({ activeTab, addons, onOpenSidebar, onAddonSelect }) {
    const currentPageTitle = tabTitles[activeTab] || 'Unknown Section';
    const [notifications, setNotifications] = useState([
        {
            id: '1',
            type: 'info',
            title: 'System Update Available',
            message: 'SpeedPress v2.1.5 is now available with new features and bug fixes.',
            time: '2 minutes ago',
            icon: Info
        },
        {
            id: '2',
            type: 'success',
            title: 'Backup Completed',
            message: 'Your store data has been successfully backed up to cloud storage.',
            time: '1 hour ago',
            icon: CheckCircle
        },
        {
            id: '3',
            type: 'warning',
            title: 'Security Alert',
            message: '3 failed login attempts detected from unknown IP address.',
            time: '3 hours ago',
            icon: AlertTriangle
        }
    ]);
    const removeNotification = (id) => {
        setNotifications(prev => prev.filter(notification => notification.id !== id));
    };
    const getNotificationColor = (type) => {
        switch (type) {
            case 'info': return 'bg-blue-500';
            case 'success': return 'bg-green-500';
            case 'warning': return 'bg-yellow-500';
            default: return 'bg-gray-500';
        }
    };
    const getNotificationIconColor = (type) => {
        switch (type) {
            case 'info': return 'text-blue-500';
            case 'success': return 'text-green-500';
            case 'warning': return 'text-yellow-500';
            default: return 'text-gray-500';
        }
    };
    return (_jsx("div", { className: "border-b border-border bg-card/80 backdrop-blur-sm sticky top-0 z-10 transition-colors duration-200", children: _jsxs("div", { className: "flex items-center justify-between px-4 md:px-8 py-4", children: [_jsxs("div", { className: "flex items-center gap-3", children: [onOpenSidebar && (_jsx(Button, { variant: "ghost", size: "icon", className: "lg:hidden", onClick: onOpenSidebar, children: _jsx(Menu, { className: "w-5 h-5" }) })), _jsx("div", { className: "hide sm:block", children: _jsx(Breadcrumb, { children: _jsxs(BreadcrumbList, { children: [_jsx(BreadcrumbItem, { children: _jsxs(BreadcrumbLink, { href: "#", className: "flex items-center gap-1.5", children: [_jsx(Home, { className: "w-4 h-4" }), "SpeedPress"] }) }), _jsx(BreadcrumbSeparator, { children: _jsx(ChevronRight, { className: "w-4 h-4" }) }), _jsx(BreadcrumbItem, { children: _jsx(BreadcrumbPage, { className: "font-medium", children: currentPageTitle }) })] }) }) }), _jsx("h1", { className: "sm:hidden font-medium text-lg", children: currentPageTitle })] }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx("div", { id: "global-search", className: "hide md:block", children: _jsx(GlobalSearch, { addons: addons, onAddonSelect: onAddonSelect }) }), _jsx(DropdownMenu, {}), _jsx(ThemeToggle, {})] })] }) }));
}
